import { Card, CardBody, Col, Input } from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";
import { SubscriberTitle } from "../../../../../Constants/Constants";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const Subscriber = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={SubscriberTitle} headClass="pb-0 border-0" />
        <CardBody>
          <P className="mb-2">To get more detail for new types of blogs.</P>
          <Input type="email" placeholder="Enter your email" />
          <Btn color="primary" className="w-100 mt-3">
            Get Started
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Subscriber;
